import type { BuiltInFormSchema } from '../types/builtInFormSchema';

export const occupancyAssessmentSchema: BuiltInFormSchema = {
  formId: 'occupancy_assessment',
  formTitle: 'Occupancy Assessment',
  sections: [
    {
      id: 'household_composition',
      title: 'Household Composition',
      fields: [
        {
          id: 'numberOfOccupants',
          label: 'How many people live in the home?',
          type: 'text',
          required: true,
          helpText: 'Enter the total number of occupants',
        },
        {
          id: 'numberOfChildren',
          label: 'How many are children (under 16)?',
          type: 'text',
          required: true,
        },
        {
          id: 'numberOfDisabled',
          label: 'How many are registered with disabilities?',
          type: 'text',
          required: true,
        },
        {
          id: 'numberOfElderly',
          label: 'How many are elderly people (65 and over)?',
          type: 'text',
          required: true,
        },
      ],
    },
    {
      id: 'sleeping_spaces',
      title: 'Sleeping Spaces',
      fields: [
        {
          id: 'singleBedSpaces',
          label: 'Number of single bed spaces?',
          type: 'text',
          required: true,
        },
        {
          id: 'doubleBedSpaces',
          label: 'Number of double bed spaces?',
          type: 'text',
          required: true,
        },
      ],
    },
    {
      id: 'customer_documents',
      title: 'Customer Documents',
      fields: [
        {
          id: 'hasCustomerDocuments',
          label: 'Customer Documents',
          type: 'boolean',
          required: true,
          helpText: 'Were customer documents taken?',
        },
        {
          id: 'customerDocumentsReason',
          label: 'Reason why customer documents weren\'t taken',
          type: 'text',
          required: false,
          conditionalOn: {
            fieldId: 'hasCustomerDocuments',
            value: false,
          },
        },
        {
          id: 'customerDocumentsPhotos',
          label: 'Customer Documents Photos',
          type: 'photo',
          required: false,
          conditionalOn: {
            fieldId: 'hasCustomerDocuments',
            value: true,
          },
        },
      ],
    },
  ],
};
